<template>
  <div class="flex flex-col space-y-4">
    <div
      v-for="(section, index) in sections"
      :key="section.id"
      class="border-neutral-95 flex w-full flex-col space-y-4 rounded-lg border px-6 py-4 shadow"
    >
      <div class="flex w-full items-center justify-between px-3">
        <div class="flex items-center space-x-4">
          <div
            class="border-primary-40 text-primary-40 relative flex h-8 w-8 items-center justify-center rounded-full border"
          >
            <span class="text-lg">
              {{ index + 1 }}
            </span>
          </div>
          <div class="bg-neutral-99 h-4 w-40 animate-pulse rounded-full" />
        </div>
        <div class="bg-neutral-99 h-4 w-20 animate-pulse rounded-full" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { Sections } from "../home.types";

withDefaults(
  defineProps<{
    sections: Sections;
  }>(),
  {},
);
</script>
